<template>
  <div
    class="min-w-8 min-h-8 border-2 border-accent text-lg rounded-full text-accent flex items-center justify-center"
  >
    <slot />
  </div>
</template>

<script setup></script>
